module.exports = __webpack_public_path__ + "static/ordered-ad0b3796e8e3f2bbb065f1240790ac3a.gif";